import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { updateRules } from '../../features/rules/rulesSlice'
import { getClientKeyWithAccessToken } from '../../lib/security'

export const useRules = (isLoading, setIsLoading, setRules, categories) => {
  const { accessToken } = useSelector((state) => state.login)
  const rulesState = useSelector((state) => state.rule)
  const dispatch = useDispatch()

  useEffect(() => {
    if (isLoading) {
      const urlGuenoRules = `${process.env.REACT_APP_BASEURL}/rulesTemplates?viewMode=true&categories=${categories.join(
        ',',
      )}`
      
      let allRules = []
      getClientKeyWithAccessToken(accessToken)
        .then((clientKey) => {
        
          const options = {
            method: 'GET',
            headers: {
              Authorization: `Bearer ${accessToken}`,
              'client-key': clientKey,
            },
          }


          return fetch(process.env.REACT_APP_IS_DEMO ? '../../data/rule-templates.json' : urlGuenoRules, options)
        })
        .then((res) => res.json())
        .then((res) => {
          const { data } = res
          if (data && Array.isArray(data)) {
            const guenoData = data.map((item) => ({ ...item, gueno: true }))
            const aux = guenoData.sort((a, b) => {
              return a.id?.split('-')[1] - b.id?.split('-')[1]
            })
            allRules.push(...aux)
          }

          dispatch(updateRules(allRules))
        })
        .catch((error) => {
          console.error('[HOOK: useRules] --> ', error)
        })
      setIsLoading(false)
    }
  }, [categories])

  useEffect(() => {
    setRules(rulesState.rules)
    setIsLoading(false)
  }, [rulesState])

  return rulesState.rules
}
